import { useTheme } from "@mui/material";
import { FC } from "react";
import { useLocalization } from "../../hooks/useLocalization";
import { ConfirmationDialog } from "../ConfirmationDialog";
import { MinSessionDurationField } from "./MinSessionDurationField";

interface MinSessionDurationDialogProps {
  isModalOpen: boolean;
  label: string;
  draft: string;
  onDraftChange: (draft: string) => void;
  handleCancel: () => void;
  handleApply: () => void;
}

export const MinSessionDurationDialog: FC<MinSessionDurationDialogProps> = ({
  isModalOpen,
  label,
  draft,
  onDraftChange,
  handleCancel,
  handleApply,
}) => {
  const theme = useTheme();
  const { t } = useLocalization();

  return (
    <ConfirmationDialog.Root
      fullWidth
      maxWidth="xs"
      onClose={handleCancel}
      open={isModalOpen}
      sx={{
        "& .MuiDialog-paper": { padding: "24px", borderRadius: "20px" },
      }}
    >
      <ConfirmationDialog.Title showIcon={false} sx={{ padding: "0px" }}>
        {label}
      </ConfirmationDialog.Title>
      <ConfirmationDialog.Content sx={{ paddingX: "0px", mt: 3, mb: 2 }}>
        <MinSessionDurationField
          draft={draft}
          onDraftChange={onDraftChange}
          onSubmit={handleApply}
          spacious
        />
      </ConfirmationDialog.Content>
      <ConfirmationDialog.Actions sx={{ padding: "0px" }}>
        <ConfirmationDialog.Button
          onClick={handleCancel}
          sx={{
            color: theme.colors.primary[5],
          }}
          variant="secondary"
        >
          {t("components.filterSelect.cancel")}
        </ConfirmationDialog.Button>
        <ConfirmationDialog.Button onClick={handleApply} variant="contained">
          {t("components.filterSelect.apply")}
        </ConfirmationDialog.Button>
      </ConfirmationDialog.Actions>
    </ConfirmationDialog.Root>
  );
};
